import { ProTip } from 'js/components/Loyalty/ProTip';
import { substituteWithDictionary } from 'js/helpers/i18n';
import { formatPrice } from 'js/helpers/price/priceUtilities';
import { CMSTreatwellRewardsPage } from 'js/model/cms/cms-treatwell-rewards';
import {
  ChannelLoyalty,
  ORDER_CHALLENGE,
} from 'js/model/rainbow/content/ChannelOutput';
import React from 'react';
import { LoyaltyContainer } from '../LoyaltyContainer';
import { SectionHeader } from '../SectionHeader';
import { TreatsConversion, TreatsConversionProps } from './TreatsConversion';
import styles from './TreatsConversionSection.module.css';

type TreatsConversionSectionProps = {
  title: string;
  description: string;
  proTip: { label: string };
  treatsConversion: TreatsConversionProps;
};
const TreatsConversionSection = ({
  title,
  description,
  proTip,
  treatsConversion,
}: TreatsConversionSectionProps) => {
  return (
    <section className={styles.root}>
      <LoyaltyContainer>
        <SectionHeader title={title} description={description} />
        <div className={styles.content}>
          <TreatsConversion
            earnRateNumerator={treatsConversion.earnRateNumerator}
            earnRateDenominator={treatsConversion.earnRateDenominator}
          />
          <div className={styles.proTip}>
            <ProTip text={proTip.label} />
          </div>
        </div>
      </LoyaltyContainer>
    </section>
  );
};

type Props = {
  channel: ChannelLoyalty;
  cmsValues: CMSTreatwellRewardsPage;
};

export const TreatsConversionSectionContainer = ({
  channel,
  cmsValues,
}: Props) => {
  const { earnRateNumerator, earnRateDenominator } =
    channel.loyalty.challenges[ORDER_CHALLENGE];
  const cms = cmsValues.page['treatwell-rewards']['treats-conversion'];
  const earnRate = formatPrice(earnRateNumerator, channel);
  const treatsConversion = {
    earnRateNumerator: {
      value: earnRate,
      label: cms.conversion['earn-rate-numerator'].label,
    },
    earnRateDenominator: {
      value: substituteWithDictionary(
        cms.conversion['earn-rate-denominator'].value,
        {
          points: String(earnRateDenominator),
        }
      ),
      label: cms.conversion['earn-rate-denominator'].label,
    },
  };

  return (
    <TreatsConversionSection
      title={cms.title}
      description={cms.description}
      proTip={{
        label: cms.footer,
      }}
      treatsConversion={treatsConversion}
    />
  );
};
